export default __webpack_public_path__ + "static/media/tennis_banner_highlight.c9c81fd8.png";